module.exports = __webpack_public_path__ + "static/media/new-york-76.c7a52bd6.jpg";